// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --componentHeight: 30px;
  --borderWidth: 3px;
  --componentHeightInner: calc(var(--componentHeight) - (var(--borderWidth) * 2));
  --btnSize: var(--componentHeightInner);
}

.app-components-Form-Toggle-___Toggle-module__toggle {
  position: relative;
  height: 30px;
  border-radius: var(--componentHeight);
  background-color: var(--colors-yuzu-primaryColor);
  border: solid var(--borderWidth) var(--colors-mainColor);
  cursor: pointer;
}

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__disabled {
    background-color: var(--colors-grey);
    border-color: var(--colors-grey);
  }

.app-components-Form-Toggle-___Toggle-module__btnContainer {
  position: relative;
  width: var(--btnSize);
  transition: width 0.3s;
}

.app-components-Form-Toggle-___Toggle-module__btn {
  position: absolute;
  width: var(--btnSize);
  height: var(--btnSize);
  border-radius: var(--btnSize);
  background-color: #fff;
  margin-right: 0;
  right: 0px;
}

.app-components-Form-Toggle-___Toggle-module__option1,
.app-components-Form-Toggle-___Toggle-module__option2 {
  height: 100%;
  top: 0px;
  position: absolute;
  color: var(--colors-yuzu-black);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  width: calc(100% - var(--btnSize));
}

.app-components-Form-Toggle-___Toggle-module__option1.app-components-Form-Toggle-___Toggle-module__active, .app-components-Form-Toggle-___Toggle-module__option2.app-components-Form-Toggle-___Toggle-module__active {
    opacity: 1;
  }

.app-components-Form-Toggle-___Toggle-module__option1 {
  right: 0px;
}

.app-components-Form-Toggle-___Toggle-module__option2 {
  left: 0px;
}

.app-components-Form-Toggle-___Toggle-module__ghost {
  display: flex;
  visibility: hidden;
}

.app-components-Form-Toggle-___Toggle-module__ghostLabel {
  padding: 0 10px;
}

:root {
  --componentHeightSmall: 20px;
  --borderWidthSmall: 2px;
  --componentHeightInnerSmall: calc(var(--componentHeightSmall) - (var(--borderWidthSmall) * 2));
  --btnSizeSmall: var(--componentHeightInnerSmall);
}

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small {
  height: var(--componentHeightInnerSmall);
  border-radius: var(--componentHeightSmall);
  border-width: var(--borderWidthSmall);
}

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small .app-components-Form-Toggle-___Toggle-module__btnContainer {
    width: var(--btnSizeSmall);
  }

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small .app-components-Form-Toggle-___Toggle-module__btn {
    width: var(--btnSizeSmall);
    height: var(--btnSizeSmall);
    border-radius: var(--btnSizeSmall);
  }

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small .app-components-Form-Toggle-___Toggle-module__option1,
  .app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small .app-components-Form-Toggle-___Toggle-module__option2 {
    width: calc(100% - var(--btnSizeSmall));
  }

.app-components-Form-Toggle-___Toggle-module__toggle.app-components-Form-Toggle-___Toggle-module__small .app-components-Form-Toggle-___Toggle-module__ghostLabel {
    padding: 0 5px;
  }
`, "",{"version":3,"sources":["webpack://./app/components/Form/Toggle/Toggle.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+EAA+E;EAC/E,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,iDAAiD;EACjD,wDAAwD;EACxD,eAAe;AAMjB;;AAJE;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;AAGF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,kCAAkC;AAKpC;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,8FAA8F;EAC9F,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,qCAAqC;AAoBvC;;AAlBE;IACE,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,kCAAkC;EACpC;;AAEA;;IAEE,uCAAuC;EACzC;;AAEA;IACE,cAAc;EAChB","sourcesContent":[":root {\n  --componentHeight: 30px;\n  --borderWidth: 3px;\n  --componentHeightInner: calc(var(--componentHeight) - (var(--borderWidth) * 2));\n  --btnSize: var(--componentHeightInner);\n}\n\n.toggle {\n  position: relative;\n  height: 30px;\n  border-radius: var(--componentHeight);\n  background-color: var(--colors-yuzu-primaryColor);\n  border: solid var(--borderWidth) var(--colors-mainColor);\n  cursor: pointer;\n\n  &.disabled {\n    background-color: var(--colors-grey);\n    border-color: var(--colors-grey);\n  }\n}\n\n.btnContainer {\n  position: relative;\n  width: var(--btnSize);\n  transition: width 0.3s;\n}\n\n.btn {\n  position: absolute;\n  width: var(--btnSize);\n  height: var(--btnSize);\n  border-radius: var(--btnSize);\n  background-color: #fff;\n  margin-right: 0;\n  right: 0px;\n}\n\n.option1,\n.option2 {\n  height: 100%;\n  top: 0px;\n  position: absolute;\n  color: var(--colors-yuzu-black);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s;\n  width: calc(100% - var(--btnSize));\n\n  &.active {\n    opacity: 1;\n  }\n}\n\n.option1 {\n  right: 0px;\n}\n\n.option2 {\n  left: 0px;\n}\n\n.ghost {\n  display: flex;\n  visibility: hidden;\n}\n\n.ghostLabel {\n  padding: 0 10px;\n}\n\n:root {\n  --componentHeightSmall: 20px;\n  --borderWidthSmall: 2px;\n  --componentHeightInnerSmall: calc(var(--componentHeightSmall) - (var(--borderWidthSmall) * 2));\n  --btnSizeSmall: var(--componentHeightInnerSmall);\n}\n\n.toggle.small {\n  height: var(--componentHeightInnerSmall);\n  border-radius: var(--componentHeightSmall);\n  border-width: var(--borderWidthSmall);\n\n  .btnContainer {\n    width: var(--btnSizeSmall);\n  }\n\n  .btn {\n    width: var(--btnSizeSmall);\n    height: var(--btnSizeSmall);\n    border-radius: var(--btnSizeSmall);\n  }\n\n  .option1,\n  .option2 {\n    width: calc(100% - var(--btnSizeSmall));\n  }\n\n  .ghostLabel {\n    padding: 0 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": `app-components-Form-Toggle-___Toggle-module__toggle`,
	"disabled": `app-components-Form-Toggle-___Toggle-module__disabled`,
	"btnContainer": `app-components-Form-Toggle-___Toggle-module__btnContainer`,
	"btn": `app-components-Form-Toggle-___Toggle-module__btn`,
	"option1": `app-components-Form-Toggle-___Toggle-module__option1`,
	"option2": `app-components-Form-Toggle-___Toggle-module__option2`,
	"active": `app-components-Form-Toggle-___Toggle-module__active`,
	"ghost": `app-components-Form-Toggle-___Toggle-module__ghost`,
	"ghostLabel": `app-components-Form-Toggle-___Toggle-module__ghostLabel`,
	"small": `app-components-Form-Toggle-___Toggle-module__small`
};
export default ___CSS_LOADER_EXPORT___;
